"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocCenterNavigationService = void 0;
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var navigator_1 = require("../navigator");
var ApplicationApi_service_1 = require("../jsonServiceApi/ApplicationApi.service");
var Cache_service_1 = require("../../../core/services/storage/Cache.service");
var utils_1 = require("../eventCollector/core/utils");
var DocCenterNavigationService = /** @class */ (function () {
    function DocCenterNavigationService(applicationApiService, cacheService, navigator) {
        this.applicationApiService = applicationApiService;
        this.cacheService = cacheService;
        this.navigator = navigator;
    }
    DocCenterNavigationService.prototype.goToHome = function (profileVersionId) {
        return __awaiter(this, void 0, void 0, function () {
            var isShowLandingPage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!profileVersionId) {
                            return [2 /*return*/, this.navigator.go('seismic.doccenter.noneprofile')];
                        }
                        return [4 /*yield*/, this.applicationApiService.getDocCenterApplicationInfo()];
                    case 1:
                        isShowLandingPage = (_a.sent()).ServiceResult
                            .DefaultProfileVersion.EnableLandingPageV2;
                        if (isShowLandingPage) {
                            this.navigator.go('seismic.doccenter.landing', { profileVersionId: profileVersionId });
                        }
                        else {
                            this.navigator.go('seismic.doccenter.main', {
                                folderId: '',
                                viewState: 'grid',
                                orderBy: 'title',
                                profileVersionId: profileVersionId,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DocCenterNavigationService.prototype.goToFolder = function (folderId, viewState, commentid, profileVersionId, searchTerm, options) {
        if (options && options.originalFolderPath) {
            if (profileVersionId) {
                this.navigator.go('seismic.doccenter.main', {
                    folderId: folderId,
                    viewState: viewState,
                    commentid: commentid,
                    profileVersionId: profileVersionId,
                    searchTerm: searchTerm,
                    originalFolderPath: options.originalFolderPath,
                });
            }
            else {
                this.navigator.go('seismic.doccenter.main', {
                    folderId: folderId,
                    viewState: viewState,
                    commentid: commentid,
                    searchTerm: searchTerm,
                    originalFolderPath: options.originalFolderPath,
                });
            }
        }
        else {
            if (profileVersionId) {
                this.navigator.go('seismic.doccenter.main', {
                    folderId: folderId,
                    viewState: viewState,
                    commentid: commentid,
                    profileVersionId: profileVersionId,
                    searchTerm: searchTerm,
                });
            }
            else {
                this.navigator.go('seismic.doccenter.main', {
                    folderId: folderId,
                    viewState: viewState,
                    commentid: commentid,
                    searchTerm: searchTerm,
                });
            }
        }
    };
    DocCenterNavigationService.prototype.goToDoc = function (state, targetState) {
        var routeParams = this.navigator.getRouteParams();
        if (window.EmbeddedPage &&
            window.EmbeddedPage.integratorContext &&
            window.EmbeddedPage.config &&
            !window.EmbeddedPage.config.openContentDetailInside) {
            window.EmbeddedPage.integratorContext.openDocCenterDetail(state, { params: routeParams });
            return;
        }
        if (targetState && targetState.isOverwrite) {
            // overwrite last record in history. this.navigator.go({state, null { location: 'replace'}}) is just replace
            window.location.replace(this.navigator.getHref('seismic.doccenter.doc', state));
        }
        else if (targetState && targetState.isForFreestyle) {
            if (targetState.isLaunchingFreestyle) {
                if (utils_1.hasOwnProperty(targetState, 'isLaunchingFreestyleAddSlides')) {
                    // this.navigator.go won't work, just use window.location.replace
                    window.location.replace(this.navigator.getHref('seismic.doccenter.doc', state));
                }
                else {
                    window.location.href = this.navigator.getHref('seismic.doccenter.doc', state);
                }
            }
            else {
                this.navigator.goBackToLastRoute();
            }
        }
        else {
            this.navigator.go('seismic.doccenter.doc', state);
        }
    };
    DocCenterNavigationService.prototype.goToRoot = function (profileVersionId, isFromeErrorPage) {
        if (isFromeErrorPage === void 0) { isFromeErrorPage = false; }
        return __awaiter(this, void 0, void 0, function () {
            var docCenterAppInfo, defaultProfileVersionId, pid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationApiService.getDocCenterApplicationInfo()];
                    case 1:
                        docCenterAppInfo = _a.sent();
                        defaultProfileVersionId = docCenterAppInfo.ServiceResult.DefaultProfileVersion.Id;
                        pid = profileVersionId || defaultProfileVersionId || this.cacheService.get('profileVersionId');
                        if (pid) {
                            this.navigator.go('seismic.doccenter', {
                                profileVersionId: pid,
                                isFromeErrorPage: isFromeErrorPage,
                            }, {
                                reload: true,
                            });
                        }
                        else {
                            this.navigator.go('seismic.doccenter', { isFromeErrorPage: isFromeErrorPage }, {
                                reload: true,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DocCenterNavigationService.prototype.goToProfileView = function (profileVersionId) {
        this.navigator.go('seismic.profileview.landing', {
            profileVersionId: profileVersionId,
        }, {
        // reload: true
        });
    };
    DocCenterNavigationService = __decorate([
        CommonService_decorator_1.CommonService('DocCenterNavigationService', { replaceAngularService: 'newDoccenterNavigation' }),
        __metadata("design:paramtypes", [ApplicationApi_service_1.ApplicationApiService,
            Cache_service_1.CacheService,
            navigator_1.SeismicNavigator])
    ], DocCenterNavigationService);
    return DocCenterNavigationService;
}());
exports.DocCenterNavigationService = DocCenterNavigationService;
//# sourceMappingURL=DocCenterNavigation.service.js.map